import { NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import { AccessDeniedComponent } from '@core/authentication/components/access-denied/access-denied.component';
import { LoginComponent } from '@core/authentication/components/login/login.component';
import { MainComponent } from '@feature/main/main.component';
import { MsalGuard } from '@azure/msal-angular';
import { CodeManagementComponent } from '@feature/components/codes/code-management/code-management.component';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login' },
    canActivate: mapToCanActivate([MsalGuard]),
    },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        redirectTo: '/code-management',
        pathMatch: 'full',
      },
      {
        path: 'code-management',
        data: { 
          title: 'Code Management',
          permissions: [
            'CodesMgmt.HCPCS.Read',
            'CodesMgmt.DMEPOSRequirements.Read',
          ]
        },
        component: CodeManagementComponent,
        canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
      },
      {
        path: 'formio',
        children: [
          {
            path: '**',
            loadComponent: () =>
              import('@feature/mfe-page/mfe-page.component').then(m => m.MfePageComponent),
            data: {
              appName: 'formio',
              title: 'Form Builder'
            }
          }
        ],
        canActivate: mapToCanActivate([MsalGuard]),
      },
      {
        path: 'page401',
        component: AccessDeniedComponent,
        data: { title: 'Access Denied' },
        canActivate: mapToCanActivate([MsalGuard]),
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/code-management'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
